import { MODE, MODE_STYLE, MODE_CLASS } from "./constant";

export function rendererCreator(renderer, ops = { mode: MODE.FREE }) {
    let getter = isFunction(renderer) ? renderer : () => renderer;
    return {
        props: ['children'],
        computed: {
            _children() {
                // 不从 props传，减少外部书写工作量
                return this.children || this.$parent.tpl.children;
            }
        },
        render(h) {
            let c = Array.isArray(this._children) ? this._children : [this._children];
            let r = c.map(element => {
                return h(getter(this), {
                    key: element.id,
                    props: {
                        tpl: element
                    },
                    style: this.$parent.setStyle(element)
                });
            });
            return h('div', {
                class: {
                    [MODE_CLASS[ops.mode]]: true
                },
                style: MODE_STYLE[ops.mode]
            }, r);
        }
    };
}


function isFunction(value) {
    return Object.prototype.toString.call(value) === '[object Function]'
}




// WEBPACK FOOTER //
// ./src/sdk/container/children.js